import React from 'react';
import { IIconProps } from '../interfaces';

const AleaFeature05Icon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '27',
  active = false,
}) => (
  <svg
    width={size}
    height={Math.floor((Number(size) / 27) * 28)} // Maintain aspect ratio based on new dimensions
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9895 17.1934H19.0013C21.1669 17.1934 22.9131 15.4955 22.9131 13.3893C22.9131 11.283 21.1669 9.5851 19.0013 9.5851H17.0736C18.4568 9.5851 19.6022 8.47336 19.6022 7.18374C19.6022 5.89412 18.8198 3.96576 16.6542 1.68164C13.7061 5.01686 12.2583 4.84302 10.5161 4.84302C8.77395 4.84302 7.98755 5.89817 7.98755 7.24438C7.98755 8.29952 8.76992 9.35063 9.79427 9.64574H7.92706C5.76141 9.64574 4.01518 11.3437 4.01518 13.4499C4.01518 15.3823 5.45895 16.963 7.38665 17.1975H5.94289C3.11182 17.1975 0.825195 19.0127 0.825195 21.7051C0.825195 24.4582 3.11182 26.6816 5.94289 26.6816H21.05C23.881 26.6816 26.1677 24.4582 26.1677 21.7051C26.1072 18.952 23.8205 17.1975 20.9895 17.1975V17.1934Z"
      fill={active ? color : '#DCDCDC'}
      stroke={active ? color : '#C6C6C6'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={active ? '1' : '0.5'}
    />
  </svg>
);

export default AleaFeature05Icon;
